/**
 * Staff Details - Form Components
 * Reusable form input components
 */
import { 
  COMMUNICATION_STYLES, WORK_STYLES, LEADERSHIP_LEVELS, CONFLICT_STYLES,
  STRESS_LEVELS, MOTIVATION_TYPES, TEAM_ROLES, EMPLOYMENT_TYPES,
  EDUCATION_LEVELS, GENDERS, MARITAL_STATUSES, RACES, RELIGIONS, STATES,
  STRENGTH_OPTIONS, IMPROVEMENT_OPTIONS
} from './constants';

// Select Field Component
export const SelectField = ({ label, value, onChange, options, placeholder = "Pilih..." }) => (
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
    >
      <option value="">{placeholder}</option>
      {options.map(opt => (
        <option key={opt} value={opt}>{opt}</option>
      ))}
    </select>
  </div>
);

// Input Field Component
export const InputField = ({ label, value, onChange, type = "text", placeholder = "" }) => (
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
    <input
      type={type}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
    />
  </div>
);

// Multi-Select Chips
export const MultiSelectChips = ({ label, selected, options, onChange }) => {
  const toggleOption = (opt) => {
    if (selected.includes(opt)) {
      onChange(selected.filter(s => s !== opt));
    } else {
      onChange([...selected, opt]);
    }
  };

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">{label}</label>
      <div className="flex flex-wrap gap-2">
        {options.map(opt => (
          <button
            key={opt}
            type="button"
            onClick={() => toggleOption(opt)}
            className={`px-3 py-1 rounded-full text-sm font-medium transition-all ${
              selected.includes(opt)
                ? 'bg-blue-600 text-white'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            {opt}
          </button>
        ))}
      </div>
    </div>
  );
};

// Section Header
export const SectionHeader = ({ icon: Icon, title, color = "blue" }) => (
  <div className={`flex items-center gap-2 mb-4 pb-2 border-b border-${color}-200`}>
    <Icon className={`w-5 h-5 text-${color}-600`} />
    <h3 className={`font-semibold text-${color}-800`}>{title}</h3>
  </div>
);

// Export field option constants for use in forms
export const FORM_OPTIONS = {
  COMMUNICATION_STYLES,
  WORK_STYLES,
  LEADERSHIP_LEVELS,
  CONFLICT_STYLES,
  STRESS_LEVELS,
  MOTIVATION_TYPES,
  TEAM_ROLES,
  EMPLOYMENT_TYPES,
  EDUCATION_LEVELS,
  GENDERS,
  MARITAL_STATUSES,
  RACES,
  RELIGIONS,
  STATES,
  STRENGTH_OPTIONS,
  IMPROVEMENT_OPTIONS
};
